import BigTemplate from "../BigTemplate";
import VideoTemplateLegacy from "../VideoTemplateLegacy";
import {
    customCommand,
    VideoBridgeInit,
    VideoBridgeReadyStatusHasReady,
    VideoBridgeReadyStatusNotReady,
    VideoBridgeReportUrls
} from "../../../api";
import {
    callDeveloperClicked,
    callDeveloperDismissed,
    callDeveloperEndCardShowSuccess,
    callDeveloperPlayCompleted,
    callDeveloperShowFailed,
    callDeveloperShowSucccess
} from "../../../api/noticeDeveloperAPI";
import {
    onSubPlayTemplateViewCloseBtnClicked,
    onSubPlayTemplateViewLoad,
    onComponentReactDeveloperCallbackCLICKED,
    onComponentReactDeveloperCallbackDISMISSED,
    onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS,
    onComponentReactDeveloperCallbackPLAYCOMPLETED,
    onComponentReactDeveloperCallbackPLAYFAILED,
    onComponentReactDeveloperCallbackPLAYSUCCESS
} from "../../../api/componentReactListener";
import {_getUrlParams} from "../../../common/m_base/util";

export default class BigTemplateAPIList extends BigTemplate {
    constructor(props) {
        super(props);

    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes});

        let MTG_SDKContext = await this.fetchSDKContext()
        console.log(MTG_SDKContext)

        if (MTG_SDKContext && MTG_SDKContext.campaignList && MTG_SDKContext.campaignList.length > 0) {
            console.log('demo 页 load ready', {MTG_SDKContext})
            VideoBridgeReadyStatusHasReady()
            if (window.MTG_RENDER) {
                window.MTG_RENDER(MTG_SDKContext)
            } else {
                console.warn('全局 window.MTG_RENDER 未注册, 请检查')
            }
        } else {
            VideoBridgeReadyStatusNotReady()
            console.error('API list 页 load 失败, campaignList 为空', {MTG_SDKContext})
        }
    }

    show(res) {
        super.show(res);


    }

    /**
     * 获取并初始化 SDK 的上下文
     * @returns {Promise<boolean|{appSetting: *, bigTemplateInstanceId: *, campaignList: *, sdkSetting: *, unitSetting: *, sdk_info: *, unit_id: *, device: *}>}
     */
    async fetchSDKContext() {
        const VideoBridgeRes = await VideoBridgeInit().catch(error => console.warn(error))
        console.log({VideoBridgeRes})

        if (typeof VideoBridgeRes === 'undefined') {
            console.warn('VideoBridge init 获取 SDK 上下文失败, VideoBridgeRes: ', VideoBridgeRes)
            return false
        }

        const unitId = VideoBridgeRes.unit_id
        const sdkInfo = VideoBridgeRes.sdk_info
        const {campaignList, appSetting, unitSetting, sdkSetting, device, userId, reward} = VideoBridgeRes

        // 获取大模板的 cmptId
        const bigTemplateInstanceId = sdkSetting && sdkSetting.instanceId
        const rootViewInstanceId = sdkSetting && sdkSetting.rootViewInstanceId
        const playVideoMute = sdkSetting && sdkSetting.playVideoMute

        // 构建 "全局" 的上下文环境对象
        this.MTG_SDKContext = {
            campaignList,
            sdkInfo,
            unitId,
            appSetting,
            unitSetting,
            sdkSetting,
            device,
            userId,
            reward,
            bigTemplateInstanceId,
            rootViewInstanceId,
            playVideoMute,
        }
        window.MTG_SDKContext = this.MTG_SDKContext

        // 将数据填充到 "当前实例" 的上下文中
        this.campaignList = campaignList
        this.sdkInfo = sdkInfo
        this.unitId = unitId
        this.appSetting = appSetting
        this.unitSetting = unitSetting
        this.sdkSetting = sdkSetting
        this.device = device
        this.userId = userId
        this.reward = reward
        this.bigTemplateInstanceId = bigTemplateInstanceId
        this.rootViewInstanceId = rootViewInstanceId
        this.playVideoMute = playVideoMute

        return this.MTG_SDKContext
    }

    customCommand({fnName, params}) {
        return customCommand({fnName, params})
    }

}